<template>
  <el-container class="auth" v-loading="loading">
      <el-header height="165" class="auth-logo">
        <img src="@/assets/img/logo/logo_cor.png" alt="logotipo da Mobile saúde" class="auth-logo-img"/>
      </el-header>
      <el-main style="min-width: 1154px;">
        <el-row>
          <el-col :span="9">
            <div class="auth-div">
              <router-link v-if="buttonBack" :to="{name: routerName}" class="auth-link" :underline="false"><img
                src="@/assets/img/icons/icon-arrow.png"/></router-link>
              <h1 class="auth-title">{{ title }}</h1>
            </div>
            <span class="auth-subtitle">{{ subTitle }}</span>
            <router-view></router-view>
          </el-col>
          <el-col :span="15">
            <span class="auth-line"> </span>
            <el-carousel :autoplay="true" :interval="5000" indicator-position="none" height="320">
              <el-carousel-item v-for="(item, index) in itens" :key="index">
                <el-image class="auth-carousel" :src="require('@/assets/' + item.url)"/>
              </el-carousel-item>
            </el-carousel>
          </el-col>
        </el-row>
      </el-main>
    <el-footer class="auth-footer" height="91px"
               :style="{'background-image': 'url(' + require('@/assets/img/footer_wave2.png') + ')'}">
     <div class="auth-footer-center">
       <div class="auth-footer-centered">
        <span class="auth-footer-center-text"> {{getYear()}} - Desenvolvido por <strong>Mobile Saúde.</strong> </span>
       </div>
     </div>
    </el-footer>
  </el-container>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
// import internalLoading from '@/components/shared/loading/InternalLoading.vue'
export default {
  // components: {
  //   internalLoading
  // },
  metaInfo: {
    title: 'Autenticação'
  },
  data () {
    return {
      title: '',
      subTitle: '',
      buttonBack: false,
      routerName: '',
      itens: [
        {
          url: 'img/login/banner1.jpg'
        },
        {
          url: 'img/login/banner2.jpg'
        },
        {
          url: 'img/login/banner3.jpg'
        },
        {
          url: 'img/login/banner4.jpg'
        }
      ]
    }
  },
  computed: {
    ...mapState('login', [
      'contexto',
      'loading',
      'sso'
    ])
  },
  methods: {
    ...mapMutations('SelecionaAplicacao', ['CLEAN']),
    getYear () {
      const d = new Date()
      return d.getFullYear()
    },
    setSSOData () {
      const queryParams = this.$route.query
      if (queryParams.token && queryParams.referer_url) {
        this.$store.dispatch('login/setLoginSSO', {
          token: queryParams.token || '',
          refererUrl: queryParams.referer_url || '',
          sandbox: (queryParams.sandbox && queryParams.sandbox === 'true')
        })
      } else {
        this.$store.dispatch('login/resetLoginSSO')
      }
    }
  },
  created () {
    // Recebe Título e subtítulo dos formulários
    this.$root.$on('set-data-auth', (data) => {
      this.title = data.title
      this.subTitle = data.subTitle
      this.buttonBack = data.buttonBack
      this.routerName = data.routerName
    })
    // Set SSO Data
    this.setSSOData()
  },
  mounted () {
    this.CLEAN()
  }
}
</script>
<style lang="sass">
  @import url('https://fonts.googleapis.com/css?family=Nunito&display=swap')
  @import './auth.scss'
</style>
